//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SysUtils from "@/utils/sysUtils";

export default {
  data() {
    return {};
  },
  computed: {
    memberId: function() {
      return this.$route.query.memberId;
    },
    companyId: function() {
      return this.$route.query.companyId;
    },
    inforImg: function() {
      if (this.$root.themeType == "yellow") {
        return require("../../assets/theme_yellow/infor.png");
      } else {
        return require("../../assets/theme_black/infor.png");
      }
    },
    remindImg: function() {
      if (this.$root.themeType == "yellow") {
        return require("../../assets/theme_yellow/remind.png");
      } else {
        return require("../../assets/theme_black/remind.png");
      }
    }
  },
  methods: {
    clickKnown() {
      SysUtils.navWeb(this.memberId, this.companyId, this.$root.themeType);
    }
  }
};



// WEBPACK FOOTER //
// ./src/views/user/remind.vue